<template>
    <v-app>
      <v-tabs v-model="active" color="primary" dark slider-color="yellow">
        <v-tab :key="2" ripple> {{ $t("locationsPage.destinationsTab") }} </v-tab>
        <v-tab-item>
          <v-container fluid>
            <v-layout align-start justify-space-around fill-height gap>
              <v-flex xs6 grow pe-4>
                <v-layout align-start justify-start column xs>
                  <v-flex xs12>
                    <h1 class="headline">{{ $t("locationsPage.editSeasonalDestinations") }}</h1>
                  </v-flex>
                  <v-flex xs12 mt-3 grow class="full-width">
                    <v-form ref="form" v-model="form" class="xs12 full-width">
                      <v-flex xs12>
                        <vue-tags-input
                          :allow-edit-tags=false
                          :avoid-adding-duplicates=true
                          :placeholder="$t('locationsPage.seasonalDestinationsPlaceholder')"
                          v-model="tag"
                          :tags="tags"
                          :autocomplete-items="filteredItems"
                          @tags-changed="newTags => tags = newTags"
                          :add-only-from-autocomplete="true"
                        />
                      </v-flex>
                      <v-flex xs12 align-end>
                      <v-btn
                        @click="updateClusters"
                        :loading="loading"
                        color="secondary"
                        >{{ $t("locationsPage.update") }}</v-btn
                      >
                    </v-flex>
                    </v-form>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-container>
        </v-tab-item>
      </v-tabs>
    </v-app>
  </template>
  <script>
  import axios from "axios";
  import VueTagsInput from "@johmun/vue-tags-input";
import { CLIENT_RENEG_LIMIT } from "tls";
  
  export default {
    name: "UpdateClusters",
    title() {
      return this.$t("locationsPage.updateSeasonalDestinationsTitle");
    },
    components: {
      VueTagsInput,
    },
    created() {
        //
    },
    data: () => ({
      active: 0,
      tag: "",
      tags: [],
      loading: false,
      error: false,
      autocompleteItems: [],
      autoCo: [],
      model: {
        destinations: [],
      },
  
      form: false,
      isLoading: false,
    }),
    mounted() {
        axios.get('/seasonal_clusters').then(response => {
            this.tags = response.data.data.map(tag => ({ text: `${tag.title}, ${tag.type}`, value:tag.id }));
        }).catch(error => {
            console.log(error)
        })
        this.searchClusters('');
    },
    computed: {
        filteredItems() {
        return this.autocompleteItems.filter(i => {
            return i.text.toLowerCase().indexOf(this.tag.toLowerCase()) !== -1;
        });
        }
    },
    methods: {
        searchClusters(query) {
            axios.get(`search_location_cluster`,{ params: { search: query } }).then(response => {
            const tags = response.data.data.map(tag => ({ text: `${tag.title}, ${tag.type}`, value:tag.id }))
            this.autocompleteItems = tags;
            // this.$refs.tagsInput.setOptions(tags)
            }).catch(error => {
            console.log('error');
            console.log(error);
            })
        },
      updateClusters() {
          const formData = new FormData();
          this.loading = true;
          this.tags.forEach((tag) => {
            formData.append("clusters[]", tag.value);
          });
          this.axios
            .post('update_seasonal_clusters', formData, {
              headers: {
                "Content-Type": "multipart/form-data",
              },
              provider: "users",
            })
            .then(() => {
              window.getApp.$emit("SHOW_TOAST", this.$t("locationsPage.destinationsUpdated"), "green");
            })
            .catch((err) => {
              console.log(err.message);
              this.error = true;
              let response = err.response;
              if (response) {
                window.getApp.$emit("SHOW_TOAST", response.data.message, "red");
                console.log(response.data);
              } else {
                window.getApp.$emit("SHOW_TOAST", this.$t("locationsPage.checkYourInfo"), "red");
              }
            })
            .then(() => (this.loading = false));
  
      },
    },
  };
  </script>
  <style lang="css">
    /* style the background and the text color of the input ... */
    .vue-tags-input {
      background: #324652;
      width: 100%;
      max-width: none !important;
    }
    
    .vue-tags-input .ti-new-tag-input {
      background: transparent;
      width: 100%;
      color: #b7c4c9;
    }
    
    .vue-tags-input .ti-input {
      background: #fafafa;
      padding: 14px 10px;
      width: 100%;
      border-radius: 4px;
      border: 1px solid black;
      transition: border-bottom 200ms ease;
    }
  
    /* we cange the border color if the user focuses the input */
    .vue-tags-input.ti-focus .ti-input {
      border: 1px solid #FF5252;
    }
  
    /* some stylings for the autocomplete layer */
    .vue-tags-input .ti-autocomplete {
      background: #e7e6e6;
      border: 1px solid #8b9396;
      border-top: none;
    }
  
    /* the selected item in the autocomplete layer, should be highlighted */
    .vue-tags-input .ti-item.ti-selected-item {
      background: #ebde6e;
      color: #283944;
    }
  
    /* style the placeholders color across all browser */
    .vue-tags-input ::-webkit-input-placeholder {
      color: #a4b1b6;
    }
  
    .vue-tags-input ::-moz-placeholder {
      color: #a4b1b6;
    }
  
    .vue-tags-input :-ms-input-placeholder {
      color: #a4b1b6;
    }
  
    .vue-tags-input :-moz-placeholder {
      color: #a4b1b6;
    }
  
    /* default styles for all the tags */
    .vue-tags-input .ti-tag {
      position: relative;
      background: #ebde6e;
      color: #283944;
      overflow: hidden;
    }
  
    /* we defined a custom css class in the data model, now we are using it to style the tag */
    .vue-tags-input .ti-tag.custom-class {
      background: transparent;
      border: 1px solid #ebde6e;
      color: #ebde6e;
      margin-inline-end: 4px;
      border-radius: 0px;
      font-size: 13px;
    }
  
    /* the styles if a tag is invalid */
    .vue-tags-input .ti-tag.ti-invalid {
      background-color: #e88a74;
    }
  
    /* if the user input is invalid, the input color should be red */
    .vue-tags-input .ti-new-tag-input.ti-invalid {
      color: #e88a74;
    }
  
    /* if a tag or the user input is a duplicate, it should be crossed out */
    .vue-tags-input .ti-duplicate span,
    .vue-tags-input .ti-new-tag-input.ti-duplicate {
      text-decoration: line-through;
    }
  
    /* if the user presses backspace, the complete tag should be crossed out, to mark it for deletion */
    .vue-tags-input .ti-tag:after {
      transition: transform .2s;
      position: absolute;
      content: '';
      height: 2px;
      width: 108%;
      inset-inline-start: -4%;
      top: calc(50% - 1px);
      background-color: #000;
      transform: scaleX(0);
    }
  
    .vue-tags-input .ti-deletion-mark:after {
      transform: scaleX(1);
    }
  </style>